import { render, staticRenderFns } from "./SettingView.vue?vue&type=template&id=1b709651&scoped=true&"
import script from "./SettingView.vue?vue&type=script&lang=js&"
export * from "./SettingView.vue?vue&type=script&lang=js&"
import style0 from "./SettingView.vue?vue&type=style&index=0&id=1b709651&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b709651",
  null
  
)

export default component.exports